import { AutocompleteInput, AutocompleteInputProps, useTranslate } from 'react-admin';
import { Box, InputLabel, OutlinedInputProps } from '@mui/material';
import { InputHelperUnderLabel } from './InputHelperUnderLabel';

export const GrayAutocompleteInputWithUpperLabel = (props: AutocompleteInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();
  const {
    helperText, isRequired, label, className, ...rest
  } = props;

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      {label !== false && (
        <InputLabel className="input-label" required={isRequired}>
          {translate(typeof label === 'string' ? label : '', { _: label })}
        </InputLabel>
      )}
      <InputHelperUnderLabel helperText={helperText} />
      <AutocompleteInput
        {...rest}
        className={className ? `${className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        TextFieldProps={{
          ...props.TextFieldProps,
          InputProps: {
            ...props.TextFieldProps?.InputProps,
            notched: false,
          } as OutlinedInputProps,
        }}
        componentsProps={{
          ...props.componentsProps,
          paper: {
            ...props.componentsProps?.paper,
            sx: {
              boxShadow: '0 2px 8px 4px lightgray',
              ...props.componentsProps?.paper?.sx,
            },
          },
        }}
        sx={props.sx}
      />
    </Box>
  );

};
